// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const nip: CountryValidator<"PL"> = createValidator(
  "pl.nip",
  145,
);

export default nip;
export const compact = nip.compact;
export const format = nip.format;
export const validate = nip.validate;
export const generate = (): string =>
  nip.generate?.() ??
  (() => {
    throw new Error(
      "Validator pl.nip cannot generate values",
    );
  })();
